export default "__VITE_ASSET__BjMl04bf__"